import {
    SectionFooter,
    SectionBody,
} from '@/components/molecules/PremiumOverview'
import { Header } from './Header'
import { useTranslation } from 'react-i18next'
import aemEnergyRealTime from '/assets/aem-energy-real-time.png'
import aemMarketShifts from '/assets/aem-market-shifts.png'
import aemSavingsSmarterPrograms from '/assets/aem-savings-smarter-programs.png'
import { Badge, Icon } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'
import { TFunction } from 'i18next'

const badgeClassName = 'h-6 w-6 !rounded-[50%]'

const boldClassName = 'text-body-medium font-bold leading-6 capitalize'

const createSections = (t: TFunction) => [
    {
        id: 'energy-real-time',
        imageProps: {
            fgSrc: aemEnergyRealTime,
            className: 'max-h-[408px]',
        },
        textProps: {
            title: t('active_management.premiumOverview.firstSection.title'),
            subtitle: t(
                'active_management.premiumOverview.firstSection.subtitle'
            ),
            list: [
                {
                    icon: (
                        <Badge variant="linkPrimary" className={badgeClassName}>
                            1
                        </Badge>
                    ),
                    text: (
                        <FormattedI18nString i18nKey="active_management.premiumOverview.firstSection.firstListItem" />
                    ),
                },
                {
                    icon: (
                        <Badge variant="linkPrimary" className={badgeClassName}>
                            2
                        </Badge>
                    ),
                    text: (
                        <FormattedI18nString i18nKey="active_management.premiumOverview.firstSection.secondListItem" />
                    ),
                },
                {
                    icon: (
                        <Badge variant="linkPrimary" className={badgeClassName}>
                            3
                        </Badge>
                    ),
                    text: (
                        <FormattedI18nString i18nKey="active_management.premiumOverview.firstSection.thirdListItem" />
                    ),
                },
            ],
        },
        reverse: false,
    },
    {
        id: 'market-shifts',
        imageProps: { fgSrc: aemMarketShifts, className: 'max-h-[408px]' },
        textProps: {
            title: t('active_management.premiumOverview.secondSection.title'),
            list: [
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.secondSection.firstListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.secondSection.secondListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.secondSection.thirdListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
            ],
        },
        reverse: true,
    },
    {
        id: 'savings-smarter-programs',
        imageProps: {
            fgSrc: aemSavingsSmarterPrograms,
            className: 'max-h-[408px]',
        },
        textProps: {
            title: t('active_management.premiumOverview.thirdSection.title'),
            list: [
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.thirdSection.firstListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.thirdSection.secondListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
                {
                    icon: <Icon name="check" />,
                    text: (
                        <FormattedI18nString
                            i18nKey="active_management.premiumOverview.thirdSection.thirdListItem"
                            boldClassName={boldClassName}
                        />
                    ),
                    textClassName: 'text-body-small',
                },
            ],
        },
        reverse: false,
    },
]

export const PremiumOverviewContainer: React.FC = () => {
    const { t } = useTranslation('translations')
    const sections = createSections(t)

    return (
        <div data-testid="premium-overview-container">
            <Header />
            {sections.map((section) => (
                <SectionBody
                    key={section.id}
                    className={section.reverse ? 'bg-white' : 'bg-neutral-50'}
                    section={section}
                />
            ))}
            <SectionFooter
                title={t('active_management.premiumOverview.footer.title')}
                subtitle={
                    <>
                        <span className="text-body-medium">
                            <FormattedI18nString
                                boldClassName="!font-normal"
                                i18nKey="active_management.premiumOverview.footer.contact"
                            />
                        </span>
                        <a
                            href="mailto:contact@myenergynetwork.com"
                            className="font-semibold text-blue-200"
                        >
                            {t(
                                'active_management.premiumOverview.footer.email'
                            )}
                        </a>
                        .
                    </>
                }
            />
        </div>
    )
}
